if (!customElements.get("discount-code")) {
  class DiscountCode extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.button = this.querySelector("button.discount-code__code[data-code]");
      if (!this.button) return;
      this.bound = true;
      this.button.addEventListener("click", this.onClick.bind(this));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    async onClick(event) {
      event.preventDefault();
      const code = this.button.dataset.code;
      if (!code) return;
      const copied = await this.copyText(code);
      if (!copied) return;
      this.button.classList.add("action-copy");
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.button.classList.remove("action-copy");
      }, 2000);
      const message = this.button.dataset.copiedMessage;
      if (message && typeof notifier !== "undefined" && notifier.show) {
        notifier.show(message, "success");
      }
    }

    async copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (error) {
          // Fall through to the legacy method below.
        }
      }
      const area = document.createElement("textarea");
      area.value = text;
      area.setAttribute("readonly", "");
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      let copied = false;
      try {
        copied = document.execCommand("copy");
      } catch (error) {
        copied = false;
      }
      document.body.removeChild(area);
      return copied;
    }
  }
  customElements.define("discount-code", DiscountCode);
}
